export default "__VITE_ASSET__BuBCuaS8__"